import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
      <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">
        {t('breadcrumbHome')}
      </Link>
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-400"></i>
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-600 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}